// extracted by mini-css-extract-plugin
module.exports =  {"loader":"_7506d987b5--loader--gIIa5","skeleton-animation":"_7506d987b5--skeleton-animation--dY1M9"};